import { useState, useEffect } from "react";
import { useRouter } from "next/compat/router";
import moment from "moment";

function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

export function useFormatDate() {
  const router = useRouter();

  const [locale, setLocale] = useState(null);

  useEffect(() => {
    setLocale(router?.locale);
  }, [router?.locale]);

  return (date) => {
    if (!locale) return null;

    const a = typeof date === "string" ? date?.replace(/\s/, "T")?.replace(/ \+.*/, "") : date;
    const d = new Date(a);
    if (!isValidDate(d)) return null;

    switch (locale) {
      case "en":
        return moment(d).format("MM/DD/YYYY");
      default:
        return moment(d).format("DD/MM/YYYY");
    }
  };
}
